import { METIME_URL, ROUTES } from "@/const.js";

export default {
  email: "support@metime.com ",
  links: [
    {
      group: "General",
      items: [
        {
          link: ROUTES.get("SIGN_UP").path,
          label: "Registration",
        },
        // {
        //   link: `${METIME_URL}/request-demo`,
        //   label: "Request a Demo",
        // },
        // {
        //   link: `${METIME_URL}/app`,
        //   label: "About the App",
        // },
      ],
    },
    {
      group: "Legal",
      items: [
        {
          link: `${METIME_URL}/terms-service`,
          label: "Terms of Service",
        },
        {
          link: `${METIME_URL}/privacy-policy`,
          label: "Privacy Policy",
        },
        {
          link: `${METIME_URL}/cookie-policy`,
          label: "Cookie Policy",
        },
      ],
    },
    {
      group: "Support",
      items: [
        {
          link: `${METIME_URL}/contact`,
          label: "Contact Us",
        },
      ],
    },
  ],
  rights: `MeTime ${new Date().getFullYear()}. All Rights Reserved.`,
  socials: [
    {
      icon: "https://metime-public.s3.eu-central-1.amazonaws.com/x_5e12c08804.svg",
      link: "https://x.com/metime_corp?lang=en",
      name: "X",
    },
    {
      icon: "https://metime-public.s3.eu-central-1.amazonaws.com/facebook_773fed6c52.svg",
      link: "https://www.facebook.com/yourmetimeapp/",
      name: "Facebook",
    },
    {
      icon: "https://metime-public.s3.eu-central-1.amazonaws.com/linkedin_7afeaf84d6.svg",
      link: "https://www.linkedin.com/company/65804278",
      name: "LinkedIn",
    },
    {
      icon: "https://metime-public.s3.eu-central-1.amazonaws.com/instagram_4a585e15af.svg",
      link: "https://www.instagram.com/metime_app/?hl=en",
      name: "Instagram",
    },
  ],
  companyName: "MeTime Corporation Limited",
  accreditationImg: {
    src: "https://metime-public.s3.eu-central-1.amazonaws.com/business_acredited_0767d0e131.png",
    url: "https://aibf.ie/times/profile/metime/",
    width: "378",
    height: "160",
    mobileWidth: "60vw",
    mobileHeight: "auto",
  },
  bestMobileAppImg: {
    src: "https://metime-public.s3.eu-central-1.amazonaws.com/noname_6594af6297.png",
    url: "https://bestmobileappawards.com/",
    width: "162",
    height: "57",
    mobileWidth: "30vw",
    mobileHeight: "auto",
  },
  firstLineAddress: "5 Fitzwilliam Square ",
  secondLineAddress: "Dublin D02R744, Ireland ",
  gdprImgSrc:
    "https://metime-public.s3.eu-central-1.amazonaws.com/gdpr_compliant_6b7605ae99.png",
  hipaaImgSrc:
    "https://metime-public.s3.eu-central-1.amazonaws.com/hipaa_compliance_3141326658.png",
};
